'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');

const BadgeStore = require('../../stores/BadgeStore');
const BadgeActions = require('../../actions/BadgeActions');

import ErrorBox from '../common/ErrorBox';
import LoadingSpinner from '../loading/LoadingSpinner';

const propTypes = {
    orgId: PropTypes.number.isRequired,
    badgeService: PropTypes.object.isRequired,
    badgeTemplate: PropTypes.object.isRequired,
    closeHandler: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

const defaultProps = {
    show: true,
    loading: false,
};

class OrgViewBadgeTemplateDetails extends React.Component {
    constructor(props) {
        super(props);
        let canSetImgSrc = false;
        if (props.badgeService) {
            let service_traits = Globals.BADGE_SERVICE_TRAITS[props.badgeService.service_type];
            if (service_traits && service_traits.missing_img_url) {
                canSetImgSrc = true;
            }
        }
        let img_src = props.badgeTemplate.img_src || '';
        this.state = { canSetImgSrc, img_src };
        this.unsubscribes = [
            BadgeStore.listen(this.onBadgeStoreChange),
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onBadgeStoreChange=(state)=>{
        if (state.action.id === this.state.updateActionId) {
            let changes = {updateActionId: null};
            if (state.action.error) {
                changes = { ...changes, updateError: state.action.error };
            }
            this.setState(changes);
        }
    }
    
    editImgSrc=(e)=>{
        let img_src = e.target.value;
        this.setState({img_src, dirty:true});
    }
    
    updateBadgeTemplate=()=>{
        let updateActionId = uuid.v4();
        this.setState({updateActionId,dirty:false},()=>{
            BadgeActions.updateBadgeTemplate(updateActionId,this.props.orgId,{
                badge_template_hash: this.props.badgeTemplate.badge_template_hash,
                updates: {
                    img_src: this.state.img_src,
                },
            });
        });
    }
    
    render() {
        return (
            <Modal
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{"Badge Template Details"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="badge-template-details">
                        <div className="row mzl-id">
                            <label>ID:</label>
                            <span>{this.props.badgeTemplate.badge_template_hash}</span>
                        </div>

                        <div className="row display-name">
                            <label>Display Name:</label>
                            <span>{this.props.badgeTemplate.display_name}</span>
                        </div>
                        
                        <div className="row badge-image">
                            {this.state.img_src ? 
                            <img className="badge-img" src={this.state.img_src}/>
                            : <span className="badge-img missing">{'no image available'}</span> }
                        </div>
                        { this.state.canSetImgSrc ? 
                        <div className="row badge-image">
                            <label>Image URL:</label>
                            <input type="text" style={{width:'100%', marginBottom:'1rem'}} value={this.state.img_src} disabled={this.state.updateActionId} onChange={this.editImgSrc}/>
                        </div>
                        : null }
                        { this.state.dirty ?
                        <Button onClick={this.updateBadgeTemplate} disabled={this.state.updateActionId}>
                            Update Badge Template
                        </Button>
                        : null }
                        {this.props.badgeTemplate.url ? 
                        <a href={this.props.badgeTemplate.url} target="_blank">full details</a>
                        : null }
                        {this.props.loading ? 
                        <div>
                            <LoadingSpinner />One moment please...
                        </div>
                        : null }
                    </div>
                    <ErrorBox allowStackTrace error={this.state.updateError} />
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        );
    }
}

OrgViewBadgeTemplateDetails.propTypes = propTypes;
OrgViewBadgeTemplateDetails.defaultProps = defaultProps;

export default OrgViewBadgeTemplateDetails;